import { render, staticRenderFns } from "./AdvertisedPayment.vue?vue&type=template&id=31b2cc8e&"
import script from "./AdvertisedPayment.vue?vue&type=script&lang=js&"
export * from "./AdvertisedPayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports